import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Bike, Phone, Key, LogIn } from 'lucide-react';

import { getBackendUrl } from '../services/origin';
const API = getBackendUrl();

export default function RiderLogin() {
  const nav = useNavigate();
  const [phone, setPhone] = useState('');
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!phone || !pin) { toast.error('Inserisci telefono e PIN'); return; }
    setLoading(true);
    try {
      const r = await axios.post(`${API}/api/rider/login`, { phone, pin });
      localStorage.setItem('rider_token', r.data.token);
      localStorage.setItem('rider_name', r.data.rider?.name || '');
      toast.success(`Benvenuto ${r.data.rider?.name || ''}!`);
      nav('/rider/dashboard');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Accesso non riuscito');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-indigo-900 p-6" data-testid="rider-login-page">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-3xl shadow-2xl p-8 space-y-5">
        <div className="text-center space-y-2">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-gradient-to-br from-[#D44E20] to-[#F59E0B] flex items-center justify-center text-white">
            <Bike size={28}/>
          </div>
          <h1 className="text-2xl font-bold text-[#1A1A1A]">Rider</h1>
          <p className="text-sm text-[#64748B]">Accedi con cellulare e PIN</p>
        </div>
        <div>
          <label className="block text-xs font-bold uppercase tracking-wider text-[#64748B] mb-1.5"><Phone size={10} className="inline mr-1"/> Cellulare</label>
          <input type="tel" value={phone} onChange={e => setPhone(e.target.value)} placeholder="+39 333 1234567" autoFocus data-testid="rider-login-phone"
            className="w-full h-12 bg-slate-50 border border-slate-200 rounded-xl px-4 text-sm focus:border-[#D44E20] focus:outline-none" />
        </div>
        <div>
          <label className="block text-xs font-bold uppercase tracking-wider text-[#64748B] mb-1.5"><Key size={10} className="inline mr-1"/> PIN</label>
          <input type="password" inputMode="numeric" value={pin} onChange={e => setPin(e.target.value)} placeholder="●●●●●●" maxLength={6} data-testid="rider-login-pin"
            className="w-full h-12 bg-slate-50 border border-slate-200 rounded-xl px-4 text-sm tracking-[0.3em] focus:border-[#D44E20] focus:outline-none" />
        </div>
        <button type="submit" disabled={loading} data-testid="rider-login-submit"
          className="w-full h-12 rounded-xl font-bold text-sm text-white bg-[#D44E20] hover:bg-[#B3421A] flex items-center justify-center gap-2 disabled:opacity-60">
          <LogIn size={16}/> {loading ? 'Accesso...' : 'Accedi'}
        </button>
        <p className="text-[11px] text-center text-[#64748B]">
          Hai dimenticato il PIN? Contatta il tuo locale.
        </p>
      </form>
    </div>
  );
}
